import { useState } from 'react';

import type { ICover } from '@gp/components/CoverUploader/types';
import type { IProjectCoverInformationVO } from '../types';

/**
 * Project cover的逻辑
 */
export default function useProjectCover() {
  // cover的信息
  const [value, setValue] = useState<IProjectCoverInformationVO>({
    cover: '',
    name: '',
    file_size: Number.NaN,
    timestamp: Number.NaN,
  });

  const resetValue = () => {
    setValue({
      cover: '',
      name: '',
      file_size: Number.NaN,
      timestamp: Number.NaN,
    });
  };

  // cover上传成功
  const handleUploadSuccess = (payload: ICover) => {
    setValue({ ...value, ...payload });
  };

  return { value, setValue, resetValue, onUploadSuccess: handleUploadSuccess };
}
